import exitIntentPopup from "../exitIntentPopup"
import primer from "../primer"

export default (getView) => (nextStepPath, popupStepPath) => ({
  ...getView(nextStepPath),
  ...primer(),
  ...exitIntentPopup(popupStepPath),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    this.initPrimer({
      checkoutCompletePath: nextStepPath,
    })
    this.initExitIntentPopup()
    this.store.restorePurchasedBasicOffer()
  },
})
